var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "eye",
    width: 60,
    height: 60,
    fill: "black",
    rx: 5,
    ry: 5
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 15,
    y: 15,
    width: 30,
    height: 30,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.8765C11.9535 7.7745 5.69999 12 1.76849 16.3275C1.35581 16.7857 1.12744 17.3804 1.12744 17.997C1.12744 18.6136 1.35581 19.2084 1.76849 19.6665C5.61449 23.9025 11.85 28.2255 18 28.122C24.15 28.2255 30.387 23.9025 34.236 19.6665C34.6487 19.2084 34.877 18.6136 34.877 17.997C34.877 17.3804 34.6487 16.7857 34.236 16.3275C30.3 12 24.0465 7.7745 18 7.8765Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 18C23.6247 19.1124 23.2946 20.1998 22.6763 21.1246C22.058 22.0495 21.1794 22.7702 20.1516 23.1957C19.1237 23.6212 17.9927 23.7324 16.9017 23.5152C15.8107 23.298 14.8085 22.7622 14.022 21.9754C13.2355 21.1887 12.6999 20.1864 12.483 19.0953C12.2661 18.0042 12.3775 16.8733 12.8033 15.8455C13.2291 14.8178 13.9501 13.9394 14.8751 13.3214C15.8001 12.7033 16.8875 12.3735 18 12.3735C18.7389 12.3733 19.4705 12.5187 20.1532 12.8014C20.8358 13.0841 21.4561 13.4986 21.9784 14.0211C22.5008 14.5436 22.9151 15.164 23.1977 15.8467C23.4802 16.5294 23.6254 17.2611 23.625 18Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.34be032f60d336c7e8cb430b6cb622b7.svg";
export { ForwardRef as ReactComponent };